module.exports = __webpack_public_path__ + "static/media/watchFav.c8bf48de.png";